import React from 'react'
import { string } from 'prop-types'

const Algebra = ({ color, ...rest }) => (
  <svg viewBox="0 0 21 21" fill="none" {...rest}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.17275 0H18.8272C20.0235 0 21 0.976517 21 2.17275V18.8272C21 20.0235 20.0235 21 18.8272 21H2.17275C0.976517 21 0 20.0235 0 18.8272V2.17275C0 0.976517 0.976517 0 2.17275 0ZM13.6859 5.84934V5.85422C13.6859 6.23506 13.3783 6.53778 13.0023 6.53778C12.6215 6.53778 12.3188 6.23018 12.3188 5.85422V5.84934V5.84445C12.3188 5.78586 12.3285 5.72727 12.3432 5.66868C12.2553 5.5808 12.0942 5.54173 11.8305 5.82004C11.5668 6.10323 11.21 7.26959 11 8.5C10.7949 10.4921 10.6343 12.9242 10.4243 13.6761C10.0337 15.0823 9.12555 15.7219 8.39316 15.8196C8.32481 15.8293 8.26133 15.8342 8.19786 15.8342C7.72425 15.8391 7.35806 15.5999 7.319 15.1995C7.319 15.1946 7.319 15.1897 7.319 15.1897C7.319 15.1848 7.319 15.18 7.319 15.1751C7.319 15.1653 7.319 15.1555 7.319 15.1458V15.1409C7.319 14.7601 7.6266 14.4573 8.00256 14.4573C8.3834 14.4573 8.68612 14.7649 8.68612 15.1409V15.1458V15.1507C8.68612 15.2093 8.67635 15.2678 8.66171 15.3264C8.74959 15.4143 8.91072 15.4534 9.17438 15.1751C9.43804 14.8919 9.69681 13.9593 9.90677 12.7289C10.1118 10.7368 10.3706 8.07091 10.5806 7.319C10.9712 5.91281 11.8793 5.27319 12.6117 5.17554C12.6801 5.16578 12.7435 5.16089 12.807 5.16089C13.2806 5.15601 13.6468 5.39526 13.6859 5.79563C13.6859 5.80051 13.6859 5.80539 13.6859 5.80539C13.6859 5.81028 13.6859 5.81516 13.6859 5.82004C13.6859 5.82981 13.6859 5.83957 13.6859 5.84934Z"
      fill={color}
    />
  </svg>
)

Algebra.propTypes = {
  color: string
}

export default Algebra
